const createTriangle = (
  doc,
  width,
  rotate,
  positionX,
  positionY,
  distance,
  animation = true,
) => {
  if (doc) {
    const height = (width * Math.sqrt(3)) / 2;
    const triangle = doc.g({
      // transform: `rotate(${rotate}) translate(${positionX}, ${positionY})`,
      class: 'c-triangle',
      transform: `t${positionX}, ${positionY}r${rotate}`,
    });
    // }).transform(`t${positionX-distance}, ${positionY-distance}r${rotate}`);
    const tShadow = triangle.polygon({
      points: `${distance} 0 ${distance} ${width} ${height + distance} ${width /
        2}`,
      fill: '#9D7CFF',
      fillOpacity: '0.5',
    });
    triangle.polygon({
      points: `0 0 0 ${width} ${height} ${width / 2}`,
      fill: '#9D7CFF',
    });
    // triangle.animate(
    //   {
    //     opacity: 1,
    //     transform: `t${positionX}, ${positionY}r${rotate}`,
    //   },
    //   500,
    //   animEIO,
    // );
    if (animation) {
      document.addEventListener('mousemove', e => {
        const xMax = window.screen.width / 2;
        const yMax = window.screen.height / 2;
        const x = Math.round((distance / 4) * ((e.clientX - xMax) / xMax));
        const y = Math.round((distance / 4) * ((e.clientY - yMax) / yMax));
        tShadow.attr({
          points: `${distance + x} ${0 + y} ${distance + x} ${width +
            y} ${height + distance + x} ${width / 2 + y}`,
        });
        // triangle.transform(`t${positionX + x}, ${positionY + y}r${rotate}`);
        triangle.attr({
          class: 'c-triangle is-active',
          transform: `t${positionX + x}, ${positionY + y}r${rotate}`,
        });
      });
      const mouseMoveEvent = document.createEvent('MouseEvents');

      mouseMoveEvent.initMouseEvent(
        'mousemove', // event type : click, mousedown, mouseup, mouseover, mousemove, mouseout.
        true, // canBubble
        false, // cancelable
        window, // event's AbstractView : should be window
        1, // detail : Event's mouse click count
        50, // screenX
        50, // screenY
        50, // clientX
        50, // clientY
        false, // ctrlKey
        false, // altKey
        false, // shiftKey
        false, // metaKey
        0, // button : 0 = click, 1 = middle button, 2 = right button
        null, // relatedTarget : Only used with some event types (e.g. mouseover and mouseout). In other cases, pass null.
      );

      document.dispatchEvent(mouseMoveEvent);
    }
  }
};

export default createTriangle;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/create-triangle.js